import { buildRoute, noEnvRoutes } from "@/assets/routes/routes";
import api from "../api";
import { isAxiosError } from "axios";

interface CreateAnswerRequest {
  body: {
    status: string;
    comment: string;
    images: string[];
    questionId: string;
  };
  inspectionId: number;
  phaseId: number;
}

export const createAnswer = async ({
  body,
  inspectionId,
  phaseId,
}: CreateAnswerRequest) => {
  try {
    const url = buildRoute(noEnvRoutes.postAnswer, {
      inspectionId: inspectionId,
      phaseId: phaseId,
    });
    const { data } = await api.post(url, body);

    return data;
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Ha habido un problema");
    }
  }
};

interface UpdateAnswerRequest {
  body: {
    status: string;
    comment: string;
    images: string[];
    questionId: string;
  };
  inspectionId: number;
  phaseId: number;
  id: number;
}

export const updateAnswer = async ({
  body,
  inspectionId,
  phaseId,
  id,
}: UpdateAnswerRequest) => {
  try {
    const url = buildRoute(noEnvRoutes.updateAnswer, {
      inspectionId: inspectionId,
      phaseId: phaseId,
      id,
    });
    const { data } = await api.put(url, body);

    return data;
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Ha habido un problema");
    }
  }
};

export const getAnswers = async ({
  inspectionId,
  phaseId,
}: {
  inspectionId: number;
  phaseId: number;
}) => {
  try {
    const url = buildRoute(noEnvRoutes.getAnswers, {
      inspectionId: inspectionId,
      phaseId: phaseId,
    });
    const { data } = await api.get(url);

    return data;
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Ha habido un problema");
    }
  }
};

export const getAnswersByPhases = async ({
  inspectionId,
  phasesId,
}: {
  inspectionId: number;
  phasesId: number[];
}) => {
  try {
    const promises = phasesId.map((phaseId: number) => {
      const url = buildRoute(noEnvRoutes.getAnswers, {
        inspectionId: inspectionId,
        phaseId: phaseId,
      });

      return api.get(url);
    });
    const results = await Promise.allSettled(promises);
    const phasesResults = { phases: {}, phaseError: [] } as any;

    results.forEach((result, index) => {
      const phaseId = phasesId[index];
      if (result.status === "fulfilled") {
        phasesResults.phases[phaseId] = result.value.data;
      } else {
        phasesResults.phaseError.push(phaseId);
      }
    });
    return phasesResults;
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Ha habido un problema");
    }
  }
};
